/**
 * #1101 — the Garages page's status dropdown holds the garage lifecycle statuses plus one pseudo-status,
 * "Documents to review". The backend `status` param is a strict enum (DOCUMENTS_PENDING would 400), so
 * that option maps to `pendingDocuments=true` with no status: the same set the dashboard's documents
 * tile counts.
 */
export const DOCUMENTS_PENDING_FILTER = 'DOCUMENTS_PENDING';

export interface GarageListParams {
  status?: string;
  search?: string;
  pendingDocuments?: boolean;
  /** Spec 074 — SIGNED (includes NOTIFIED, v2) | NOT_SIGNED; combines with the status filter. */
  termsStatus?: string;
}

/** Spec 074 v2 — the values the Terms dropdown (and the `terms` URL param) accepts: Signed / Not signed. */
export const TERMS_STATUS_FILTERS = ['SIGNED', 'NOT_SIGNED'] as const;

/**
 * An unknown `terms` value (a hand-edited URL) is dropped rather than sent: the backend enum would 400.
 * A v1 link with `terms=NOTIFIED` opens as Signed, which now includes it.
 */
export function normalizeTermsFilter(value: string | null | undefined): string {
  if (value === 'NOTIFIED') return 'SIGNED';
  return value && (TERMS_STATUS_FILTERS as readonly string[]).includes(value) ? value : '';
}

export function garageListParams(filter: string, search: string, termsFilter = ''): GarageListParams {
  const trimmed = search.trim() || undefined;
  const termsStatus = normalizeTermsFilter(termsFilter) || undefined;
  const terms = termsStatus ? { termsStatus } : {};
  if (filter === DOCUMENTS_PENDING_FILTER) {
    return { pendingDocuments: true, search: trimmed, ...terms };
  }
  return { status: filter || undefined, search: trimmed, ...terms };
}
